export default __webpack_public_path__ + "static/media/default-user.48d0691a.png";